import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const dataSourcesApi = {
  /**
   * List scraped articles with optional filtering.
   * @param {{
   *   date?: string;       // "YYYY-MM-DD"
   *   topic?: string;
   *   search?: string;     // searches title
   *   status?: 'active'|'inactive'|'pending'|'archived';
   *   source?: string;
   *   start_time?: string; // "HH:MM"
   *   time_field?: 'scraped_at'|'published_at';
   *   skip?: number;
   *   limit?: number;
   * }} [params]
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').RawDataItem[]>>}
   */
  list: (params = {}, config = {}) =>
    mod.get('/data-sources/', { ...config, params: { limit: 100, ...params } }),

  /**
   * Returns dates that have articles, newest first.
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').DateCount[]>>}
   */
  listDates: (config) => mod.get('/data-sources/dates', config),

  /**
   * @param {number} id
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  get: (id, config) => mod.get(`/data-sources/${id}`, config),

  /**
   * Attach an existing catalog topic to an article.
   * @param {number} rawDataId
   * @param {{ topic_id: number }} body
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  addTopic: (rawDataId, body, config) =>
    mod.post(`/data-sources/${rawDataId}/topics`, body, config),

  /**
   * Remove a catalog topic from an article.
   * @param {number} rawDataId
   * @param {number} topicId
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  removeTopic: (rawDataId, topicId, config) =>
    mod.delete(`/data-sources/${rawDataId}/topics/${topicId}`, config),

  /**
   * Add a company to an article's latest analysis result.
   * @param {number} rawDataId
   * @param {{ company: string }} body
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  addCompany: (rawDataId, body, config) =>
    mod.post(`/data-sources/${rawDataId}/companies`, body, config),
};
